(function () {
  var gallery = document.querySelector('.template-product .main-image');
  if (!gallery || !('IntersectionObserver' in window)) return;

  /* Once the topbar activates (gallery scrolled out of view above viewport), keep it
     permanently active for the rest of the page visit — it should never disappear
     again regardless of scroll direction. The observer disconnects itself after the
     first activation so it cannot accidentally remove the class. */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (scrolledPast) {
        document.body.classList.add('pdp-topbar-active');
        // Disconnect immediately — topbar stays on for the rest of the visit
        observer.disconnect();
      }
    });
  }, { threshold: 0 });

  observer.observe(gallery);
})();
